import React, { memo } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useAppDispatch, useAppSelector } from "../app/hooks/reduxHooks";
import { setDialogOpen } from "../app/pageIndexSlice";
import clsx from "clsx";
import { toSnakeCase } from "../Sidebar/Sidebar";
import { Close, Logo } from "../icons";
import styles from './Menu.module.sass'
import { HomePageConfig } from "../configuration";

function Menu({ list }) {
  const open = useAppSelector((state) => state.pageIndex.dialogOpen);
  const pageIndex = useAppSelector((state) => state.pageIndex.index);
  const dispatch = useAppDispatch();
  const handleClick = () => {
    dispatch(setDialogOpen(false));
  };
  return (
    <Dialog
      fullWidth
      disableScrollLock
      fullScreen
      disableEnforceFocus
      disableAutoFocus
      keepMounted
      disableRestoreFocus
      onClose={handleClick}
      open={open}
    >
      <div className={styles.root}>
        <a href={HomePageConfig.logoHref} className={styles.logo} >
          <Logo />
        </a>
        <button
          onClick={handleClick}
          className={clsx(styles.close, open && styles.rotate)}
        >
          <Close />
        </button>
        {list.map((e, i) => {
          return (
            <a
              key={i}
              onClick={() => handleClick()}
              href={`#${toSnakeCase(e)}`}
              className={clsx(styles.p, pageIndex === i && styles.pActive)}
            >
              {e}
            </a>
          );
        })}
      </div>
    </Dialog>
  );
}

export default memo(Menu);
